import { useApiUrl, useCustomMutation, useInvalidate } from "@refinedev/core";
import { showNotification } from "@mantine/notifications";
import { Review } from "entities/review";

export function usePublishReview() {
  const apiUrl = useApiUrl();
  const invalidate = useInvalidate();
  const { mutate, isLoading } = useCustomMutation<Review>();

  const run = (id: number, action: "publish" | "unpublish") => {
    mutate(
      {
        url: `${apiUrl}/reviews/${id}/${action}`,
        method: "post",
        values: {},
      },
      {
        onSuccess: () => {
          showNotification({
            title: action === "publish" ? "Published" : "Unpublished",
            message: `Review #${id} has been ${action === "publish" ? "published" : "unpublished"}.`,
            color: "green",
          });
          invalidate({ resource: "reviews", invalidates: ["list", "detail"], id });
        },
        onError: () => {
          showNotification({
            title: "Error",
            message: `Failed to ${action} review #${id}.`,
            color: "red",
          });
        },
      },
    );
  };

  return {
    publish: (id: number) => run(id, "publish"),
    unpublish: (id: number) => run(id, "unpublish"),
    isLoading,
  };
}
